<form [formGroup]="group">
    <h5>¡Postularme para Titán!</h5>
    <div class="titans-form">
        <div class="form-section1" *ngIf="contadorButton === 0">
            <!-- Nombres -->
            <mat-form-field>
                <mat-label>Nombres</mat-label>
                <input matInput maxlength="40" placeholder="Escribe tu nombre" formControlName="name">
            </mat-form-field>
            <!-- Apellidos -->
            <mat-form-field hintLabel="Max 10 characters">
                <mat-label>Apellidos</mat-label>
                <input matInput maxlength="80" placeholder="Escribe tu apellido" formControlName="lastName">
            </mat-form-field>
            <!-- TipoDocumento -->
            <mat-form-field>
                <mat-label>Tipo de documento</mat-label>
                <mat-select (valueChange)="change($event)" formControlName="typeDocument">
                    <mat-option *ngFor="let typeDocument of typeDocuments"
                        value="{{typeDocument.code}}">{{typeDocument.description}}</mat-option>
                </mat-select>
            </mat-form-field>
            <!-- Documentos -->
            <mat-form-field *ngIf="textDocument !== ''">
                <mat-label>{{textDocument}}</mat-label>
                <input matInput maxlength="40" placeholder="Escribe tu {{textDocument}}"
                    formControlName="numberDocument">
            </mat-form-field>
            <!-- Correo -->
            <mat-form-field hintLabel="Max 10 characters">
                <mat-label>Correo electrónico</mat-label>
                <input matInput type="email" maxlength="40" placeholder="Escribe tu correo electrónico"
                    formControlName="email">
            </mat-form-field>
        </div>

        <!-- Steeper 2 -->

        <div class="form-section2" *ngIf="contadorButton === 1">
            <!-- CountryCode -->
            <div class="mama">
                <div class="countrydiv">
                    <mat-form-field>
                        <mat-label>País</mat-label>
                        <mat-select formControlName="country">
                            <mat-option *ngFor="let countryCode of countryCodes"
                                value="+{{countryCode.callingCode}}">+{{countryCode.callingCode}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <!-- Celular -->
                <div class="celldiv">
                    <mat-form-field hintLabel="Max 15 characters">
                        <mat-label>Celular</mat-label>
                        <input matInput formControlName="phone" maxlength="80"
                            placeholder="Escribe tu número de celular">
                    </mat-form-field>
                </div>
            </div>
            <!-- Gender -->
            <mat-form-field>
                <mat-label>Sexo</mat-label>
                <mat-select formControlName="gender">
                    <mat-option *ngFor="let gender of genders"
                        value="{{gender.code}}">{{gender.description}}</mat-option>
                </mat-select>
            </mat-form-field>
            <!-- CalendarMinWidth-MaxWidth -->
            <mat-form-field>
                <mat-label>Fecha de nacimiento DD/MM/AAAA</mat-label>
                <input matInput appDateMask inputmode="numeric" [min]="minDate" [max]="maxDate" [matDatepicker]="picker" formControlName="birthdate" name="birthdate">
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <!-- Departmenent -->
            <mat-form-field>
                <mat-label>Departamento de residencia</mat-label>
                <mat-select (valueChange)="changeMunicipality($event)" formControlName="department">
                    <mat-option *ngFor="let DepartmentDescription of departmentsDescription"
                        value="{{DepartmentDescription.code}}">{{DepartmentDescription.description}}</mat-option>
                </mat-select>
            </mat-form-field>
            <!-- Municipality -->
            <mat-form-field>
                <mat-label>Ciudad o municipio de residencia</mat-label>
                <mat-select formControlName="city" (valueChange)="changeLocalities($event)">
                    <mat-option *ngFor="let Municipality of municipalities"
                        value="{{Municipality.code}}">{{Municipality.description}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="localities && localities.length">
                <mat-label>Localidad de residencia</mat-label>
                <mat-select formControlName="locality">
                    <mat-option *ngFor="let Locality of localities"
                        value="{{Locality.code}}">{{Locality.description}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Steeper 3 -->

        <div class="form-section3" *ngIf="contadorButton === 2">
            <h6>¡Queremos conocerte!
                <br><br>
                Tienes experiencia en?
                <span class="tooltip--mensaje">
                    <div class="question-icon">?</div>
                    <span class="tooltiptext">Debes selecionar al menos 1 opcion</span>
                </span>
            </h6>
            <div class="error-message" *ngIf="group.get('experiences')?.invalid">
                Seleccionar minimo un valor.
            </div>
            <!-- CheckBoxes -->
            <div class="checkboxStyles" *ngFor="let item of checkboxes; let i = index">
                <label for="cbox{{i}}" class="tooltip-container">
                    <input type="checkbox" id="cbox{{i}}" [value]="item.value" [checked]="item.checked"
                        (change)="onCheckboxChange(i)" [disabled]="item.disabled" />
                    <span class="selectCheck">{{item.label}}</span>
                </label>
                <br><br>
            </div>
            <!-- OS -->
            <div class="os">
                <mat-form-field>
                    <mat-label>¿Qué sistema operativo tiene tu celular?</mat-label>
                    <mat-select formControlName="system" required>
                        <mat-option value="Android">Android</mat-option>
                        <mat-option value="IOS">IOS</mat-option>
                        <mat-option value="Windows Phone">Windows Phone</mat-option>
                        <mat-option value="BlackBerry">BlackBerry</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="os">
                <mat-form-field>
                    <mat-label>¿Donde quieres recibir tus comisiones?</mat-label>
                    <mat-select formControlName="commissions" required>
                        <mat-option value="NEQUI">NEQUI</mat-option>
                        <mat-option value="DAVIPLATA">DAVIPLATA</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Terminos -->
            <div class="termsCheck">
                <label>
                    <input type="checkbox" name="terminos" formControlName="terminos">
                </label>
                Acepto las
                <span (click)="abrirPopupterms()" class="politycsURL">&nbsp;Política de Tratamiento de Datos. </span>
            </div>

        </div>

        <button id="backButton" type="button" class="backButton" *ngIf="contadorButton !== 0"
            (click)="backPage()">{{textButtonAnt}}</button>
        <button id="nextButton" class="nextButton" *ngIf="contadorButton != 2" type="button"
            (click)="nextPage()">{{textButton}}</button>
        <button id="nextButton" class="nextButton" type="button" *ngIf="contadorButton === 2"
            (click)="group.valid && send()" [disabled]="group.invalid">
            {{ textButton }}
        </button>
    </div>
</form>